import { Descriptions, Typography } from 'antd'
import { createStyles } from 'antd-style'
import { toNumber } from 'lodash'

import { CertificationDescriptionProps } from './interface'

const useStyles = createStyles(({ prefixCls }) => ({
  description: {
    [`& .${prefixCls}-descriptions-row td `]: {
      paddingBottom: '0'
    }
  }
}))

export const CertificationDescription = ({
  data
}: CertificationDescriptionProps) => {
  const { styles } = useStyles()
  const { name, businessProject, code, timeType, beginTime, endTime } = data
  console.log('data', data)
  const validTimeLimitText =
    toNumber(timeType) === 1 ? '永久有效' : `${beginTime} 至 ${endTime}`

  return (
    <Descriptions className={styles.description} column={1}>
      <Descriptions.Item label='资质类型'>{name}</Descriptions.Item>
      <Descriptions.Item label='经营项目'>
        <Typography.Text ellipsis>{businessProject}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label='编号代码'>
        <Typography.Text ellipsis>{code}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label='有效期限'>
        {validTimeLimitText}
      </Descriptions.Item>
    </Descriptions>
  )
}
